export const formatPhoneNumber = (number) => {
  const phoneNumber = number.toString();

  const countryCode = phoneNumber.slice(0, 1);
  const areaCode = phoneNumber.slice(1, 4);
  const firstPart = phoneNumber.slice(4, 7);
  const secondPart = phoneNumber.slice(7);

  return `+${countryCode} (${areaCode}) ${firstPart}-${secondPart}`;
};

export const colorEachRow = (worksheet) => {
  for (let rowIndex = 1; rowIndex <= worksheet.rowCount; rowIndex++) {
    const row = worksheet.getRow(rowIndex);

    if (row.getCell(2).font?.bold) continue;

    const fillColor = rowIndex % 2 === 1 ? { argb: 'D1E3F8' } : { argb: 'FFFFFF' };

    row.eachCell({ includeEmpty: true }, (cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: fillColor,
      };
    });
  }
};
